export default __webpack_public_path__ + "static/media/5.6b4b6a7a.jpg";